module.exports = __webpack_public_path__ + "static/semantic-card-image-eaa2e0fa3cf2de9ba0105ca9a5f259fa.png";